module.exports = __webpack_public_path__ + "img/icon_billing.6bbb2cf5.svg";